import C from '../constants';

export const changeLocale = (locale, activeLanguage ) => {
    return {
        type: C.CHANGE_LANG,
        locale: locale,
        activeLanguage: activeLanguage,
    }
};



// WEBPACK FOOTER //
// src/actions/language.jsx